export default function Spinner({ text = 'Loading...' }: { text?: string }) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" />
      <span>{text}</span>
    </div>
  );
}
